import styled from 'styled-components';

export const TabMenuItem = styled.div<{ isActive: boolean }>`
  display: flex;
  flex-direction: row;
  background-color: ${({ isActive }) => (isActive ? '#434343CC' : '#ebebeb')};
  color: ${({ isActive }) => (isActive ? '#fff' : '#434343 ')};
  width: 175px;
  height: 54px;
  padding: 14px 24px 12px 24px;
  font-size: 17px;
  font-weight: 600;
  :hover {
    background-color: #434343;
    color: #fff;
    cursor: pointer;
  }
`;

export const IconWrapper = styled.div<{ rotate?: boolean }>`
  margin: 0px 10px 0px 20px;
  transform: ${({ rotate }) => (rotate ? 'rotate(45deg)' : 'none')};

  svg {
    fill: ${({ theme }) => theme.palette.primaryBrandDark};
  }
`;

export const TextWrapper = styled.div`
  :hover {
    color: #fff;
  }
`;
